import { useContext } from "react";
import { TutorialContext } from "./TutorialProvider";

export const useTutorial = () => {
  const ctx = useContext(TutorialContext);
  if (!ctx) {
    throw new Error("useTutorial must be used within a TutorialProvider");
  }
  return ctx;
};
